import { buildQueryString } from '../../../utils/CommonFunction';
import Utils from '../../../utils';
import {
  failedOrderListReducer,
  loaderListener,
  successOrderListReducer
} from '../Slice/orderListSlice';

export const fetchOrderListApiCall = (values, dispatch, orderList, isSw) => {
  const { pageNo, limit, searchKey, vendors__id, ordering, start_at, end_at, payment_method } =
    values;

  let dataToSend = {
    search: searchKey,
    ordering,
    vendors__id,
    start_at,
    end_at,
    ...(isSw && { sw: isSw })
  };
  if (payment_method === 'stripe') dataToSend.payment_method = '1';
  if (payment_method === 'account') dataToSend.payment_method = '2';
  if (pageNo) {
    dataToSend.page = pageNo;
  }
  if (limit) {
    dataToSend.page_size = limit;
  }
  // Define an array of keys to check for falsy values
  const keysToDelete = ['search', 'ordering', 'start_at', 'end_at'];

  // Iterate through the keys and delete them if they are falsy in dataToSend
  keysToDelete.forEach((key) => {
    if (!dataToSend[key]) {
      delete dataToSend[key];
    }
  });

  dispatch(
    loaderListener({
      loading: true
    })
  );

  const result = buildQueryString(dataToSend);
  Utils.api.getApiCall(
    `${Utils.EndPoint.vendorEndpoints.orderApi}`,
    Object.keys(dataToSend).length == 0 ? '' : `?${result}`,
    (respData) => {
      const { data } = respData;
      dispatch(
        loaderListener({
          loading: false
        })
      );
      dispatch(
        successOrderListReducer({
          data: [...orderList, ...data?.data] || data,
          total: data?.page?.total_records || data.length,
          loading: false
        })
      );
    },
    (error) => {
      Utils.showAlert(2, error.detail || error.message);
      dispatch(failedOrderListReducer(error.detail));
    }
  );
};
